export var labels = [  
  'web_outofstock', // Out of stock
  '_cartItemsErrorMessage', // Your cart had to be adjusted to meet the limits, see changes
  '_removeCarts', // Remove carts
  '_webservererror', // An error has ocurred
  '_webcartempty', //Web Cart Empty
  'Prod_Quantity', // Quantity
  'update', // Update
  '_unitprice', // Unit Price
  '_remove', // Remove
  'subtotal', // SubTotal
  'placeorder', // Place Order
  '_done', // Done
  '_shippingChargesWillBeCalculated', // Shipping charges will be calculated during payment if applicable
  'attachment'
];